import { ActionType, createAsyncAction } from 'typesafe-actions'
import { UserState } from '../../types'
import { Failure, Request, Success } from './types'

export const updateUserAction = createAsyncAction(
  '@user/UPDATE_USER_REQUEST',
  '@user/UPDATE_USER_SUCCESS',
  '@user/UPDATE_USER_FAILURE'
)<Request, Success, Failure>()

const request = (state: UserState): UserState => ({
  ...state,
  isLoadingUpdateUser: true,
  isErrorOnLoadingUpdateUser: false,
  isSuccessOnLoadingUpdateUser: false
})

const success = (state: UserState, action: ActionType<typeof updateUserAction.success>): UserState => ({
  ...state,
  isLoadingUpdateUser: false,
  isErrorOnLoadingUpdateUser: false,
  isSuccessOnLoadingUpdateUser: true,
  userAuthenticated: action.payload.userAuthenticated
})

const failure = (state: UserState): UserState => ({
  ...state,
  isLoadingUpdateUser: false,
  isSuccessOnLoadingUpdateUser: false,
  isErrorOnLoadingUpdateUser: true
})

export const updateUserHandle = { asyncAction: updateUserAction, request, success, failure }
